export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

export const setCookie = (name, value, days) => {
  const date = new Date();
  const parsedDays = Number(days);
  const lifetimeDays = Number.isFinite(parsedDays) && parsedDays > 0 ? parsedDays : 1;
  date.setTime(date.getTime() + lifetimeDays * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax${secure}`;
};
